module.exports = __webpack_public_path__ + "static/media/6.bc0035dd.svg";